export default "__VITE_ASSET__DxSZqTSs__"